import { ProspectoCab } from './../../../models/ProspectoCab';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FiltrosProspecto } from '../../../models/FiltrosProspecto';
import { MessagesDates, MessagesGeneral, MessagesTitles } from 'app/models/messages';
import { ProspectosService } from 'app/services/operaciones/prospectos/prospectos.service';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { exportJsonToExcel } from 'app/shared/servifin-excel.export';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-listado-operaciones-prospectos',
  templateUrl: './listado-operaciones-prospectos.component.html',
  styleUrls: ['./listado-operaciones-prospectos.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DecimalPipe, DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoOperacionesProspectosComponent implements OnInit, OnDestroy {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  DTOFiltrosProspectos: FiltrosProspecto = new FiltrosProspecto();
  prospectos: ProspectoCab[] = [];
  today = moment();
  prospecto: any;
  bodyProspecto: FormGroup;
  loading: boolean;
  user: any;
  abrirNuevoProspecto: boolean = false;
  abrirProspectoDetalle: boolean = false;
  value = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['checked', 'idProspecto', 'Ruc_Adquirente', 'Razon_Social_Adq', 'Ruc_Proveedor', 'Razon_Social_Prov', 'MonedaDsc', 'Monto_Comercial', 'Tipo_Documento_Desc', 'Fecha_Registro', 'Estado']
  dataSource: any;
  subLista: Subscription[] = [];
  subProspecto: Subscription = new Subscription();
  idEncrip:any;
  constructor(
    private datepipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private prospectoService: ProspectosService,
    private formBuilder: FormBuilder
  ) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.DTOFiltrosProspectos.FechaIni = this.datepipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosProspectos.FechaFin = this.datepipe.transform(moment(), 'yyyy-MM-dd');
  }

  applyFilter(filterValue: string) {
    if (null != this.dataSource) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  ngOnInit() {
    this.ListadoProspectos();
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  ExportTOExcel() {
    exportJsonToExcel(this.prospectos, 'Prospectos', 'Reporte_Prospecto');
  }

  VerDetalle(element) {
    this.prospecto = element;
    this.abrirProspectoDetalle = true;
  }

  CerrarPopUp() {
    this.abrirProspectoDetalle = false;
  }

  ListadoProspectos() {
    /* this.idEncrip=Buffer.from(this.user.id_user.toString()).toString('base64'); */
    this.DTOFiltrosProspectos.user_id=this.idEncrip;
    this.loading = true;
    this.DTOFiltrosProspectos.FechaIni = this.datepipe.transform(this.DTOFiltrosProspectos.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosProspectos.FechaFin = this.datepipe.transform(this.DTOFiltrosProspectos.FechaFin, 'yyyy-MM-dd');
    this.DTOFiltrosProspectos.Version = 1;
    this.subProspecto = this.prospectoService.obtenerProspectoCab(this.DTOFiltrosProspectos).subscribe(
      res => {
        this.prospectos = res;
        this.prospectos.forEach((prospectoCabItem: ProspectoCab) => {
          prospectoCabItem.Monto_Comercial = Number(prospectoCabItem.Monto_Comercial).toFixed(2);
        });
        this.dataSource = new MatTableDataSource(this.prospectos);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },
      err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.loading = false;
      }
    );

    this.subLista.push(this.subProspecto);
  }

  Refresh() {
    window.location.reload();
  }

  DarBajaProspecto(prospecto: any) {
    this.bodyProspecto = this.formBuilder.group({
      Baja_Usuario: this.user.Usuario
    });
    Swal.fire({
      title: 'Atención',
      text: '¿Estás seguro en dar de baja el prospecto?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja.',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud...',
          heightAuto: false
        });
        Swal.showLoading();

        this.prospectoService.darBajaProspectoCab(prospecto.idProspecto, this.bodyProspecto.getRawValue()).subscribe(
          res => {
            this.ListadoProspectos();
            Swal.fire({
              title: '¡Éxito!',
              text: 'El prospecto se ha dado de baja exitosamente.',
              type: 'success',
              heightAuto: false
            });
          },
          () => {
            Swal.fire({
              title: "Error",
              text: "No se pudo dar de baja el prospecto.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          });
      }

    });
  }

}